import { render, staticRenderFns } from "./TituloPagina.vue?vue&type=template&id=a681c49a&scoped=true&"
import script from "./TituloPagina.vue?vue&type=script&lang=js&"
export * from "./TituloPagina.vue?vue&type=script&lang=js&"
import style0 from "./TituloPagina.vue?vue&type=style&index=0&id=a681c49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a681c49a",
  null
  
)

export default component.exports